import { Box, Button, Card, CardHeader, CardBody, Heading, Text, VStack } from '@chakra-ui/react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { StatementOfAccountForm } from '@/components/forms/StatementOfAccountForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditSoaPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ shippingLineId: string; soaId: string }>()
  const paramsShippingLineId = params.shippingLineId
  const soaId = params.soaId ? parseInt(params.soaId, 10) : undefined

  // Get data from navigation state or route params
  const navigationState = location.state as
    | {
        selectedBookingIds?: number[]
        shippingLineName?: string
        shippingLineId?: string
        soaId?: number
        expectedDateFrom?: string
        expectedDateTo?: string
      }
    | null
  const selectedBookingIds = navigationState?.selectedBookingIds || []
  const shippingLineName = navigationState?.shippingLineName || ''
  const finalShippingLineId =
    navigationState?.shippingLineId || paramsShippingLineId
  const finalSoaId = navigationState?.soaId || soaId
  const expectedDateFrom = navigationState?.expectedDateFrom
  const expectedDateTo = navigationState?.expectedDateTo

  const handleSuccess = () => {
    if (finalShippingLineId) navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
    else navigate('/shipping-lines')
  }

  const handleCancel = () => {
    if (finalShippingLineId) navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
    else navigate('/shipping-lines')
  }

  if (!finalShippingLineId || finalSoaId == null || !Number.isFinite(finalSoaId)) {
    return (
      <AdminLayout constrainedContent>
        <Box p={4}>
          <Text color={colors.textSecondary} mb={4}>
            Missing shipping line or SOA. Please go back and try again.
          </Text>
          <Button size="sm" variant="outline" onClick={() => navigate('/shipping-lines')}>
            Back to Shipping Lines
          </Button>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout constrainedContent>
      <Box
        p={4}
        minW={0}
        h="100%"
        overflow="auto"
        display="flex"
        flexDirection="column"
      >
        <VStack spacing={0} align="stretch" flex="1" minH={0} minW={0}>
          <Card minW={0}>
            <CardHeader>
              <Heading size="md" mb={1}>
                Edit Statement of Account
              </Heading>
              <Text fontSize="sm" color={colors.text}>
                Update Statement of Account details
              </Text>
            </CardHeader>
            <CardBody minW={0} overflow="visible">
              <StatementOfAccountForm
                shippingLineId={finalShippingLineId}
                shippingLineName={shippingLineName}
                selectedBookingIds={selectedBookingIds}
                soaId={finalSoaId}
                expectedDateFrom={expectedDateFrom}
                expectedDateTo={expectedDateTo}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
              />
            </CardBody>
          </Card>
        </VStack>
      </Box>
    </AdminLayout>
  )
}

